export default "__VITE_ASSET__H7s9pbjP__"